function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/converters/tableproperites
 */

/**
 * Conversion helper for upcasting attributes using normalized styles.
 *
 * @param {module:engine/conversion/conversion~Conversion} conversion
 * @param {String} modelElement
 * @param {String} modelAttribute
 * @param {String} styleName
 */
export function upcastStyleToAttribute(conversion, modelElement, modelAttribute, styleName) {
  conversion.for('upcast').attributeToAttribute({
    view: {
      styles: _defineProperty({}, styleName, /[\s\S]+/)
    },
    model: {
      name: modelElement,
      key: modelAttribute,
      value: function value(viewElement) {
        return viewElement.getNormalizedStyle(styleName);
      }
    }
  });
}
/**
 * Conversion helper for upcasting border styles for view elements.
 *
 * @param {module:engine/conversion/conversion~Conversion} conversion
 * @param {String} viewElementName
 */

export function upcastBorderStyles(conversion, viewElementName) {
  conversion.for('upcast').add(function (dispatcher) {
    return dispatcher.on('element:' + viewElementName, function (evt, data, conversionApi) {
      // TODO: this is counter-intuitive: ie.: if only `border-top` is defined then `hasStyle( 'border' )` also returns true.
      // TODO: this might needs to be fixed in styles normalizer.
      var stylesToConsume = ['border-top', 'border-right', 'border-bottom', 'border-left'].filter(function (styleName) {
        return data.viewItem.hasStyle(styleName);
      });

      if (!stylesToConsume.length) {
        return;
      }

      var matcherPattern = {
        styles: stylesToConsume
      }; // Try to consume appropriate values from consumable values list.

      if (!conversionApi.consumable.test(data.viewItem, matcherPattern)) {
        return;
      } // This can happen when the upcasted table is nested table. As to why it happens, it remains a mystery.
      // Take a look at https://github.com/ckeditor/ckeditor5/issues/6177.


      if (!data.modelRange) {
        data = Object.assign(data, conversionApi.convertChildren(data.viewItem, data.modelCursor));
      }

      var modelElement = _toConsumableArray(data.modelRange.getItems({
        shallow: true
      })).pop();

      conversionApi.consumable.consume(data.viewItem, matcherPattern);
      conversionApi.writer.setAttribute('borderStyle', data.viewItem.getNormalizedStyle('border-style'), modelElement);
      conversionApi.writer.setAttribute('borderColor', data.viewItem.getNormalizedStyle('border-color'), modelElement);
      conversionApi.writer.setAttribute('borderWidth', data.viewItem.getNormalizedStyle('border-width'), modelElement);
    });
  });
}
/**
 * Conversion helper for downcasting an attribute to a style.
 *
 * @param {module:engine/conversion/conversion~Conversion} conversion
 * @param {String} modelElement
 * @param {String} modelAttribute
 * @param {String} styleName
 */

export function downcastAttributeToStyle(conversion, modelElement, modelAttribute, styleName) {
  conversion.for('downcast').attributeToAttribute({
    model: {
      name: modelElement,
      key: modelAttribute
    },
    view: function view(modelAttributeValue) {
      return {
        key: 'style',
        value: _defineProperty({}, styleName, modelAttributeValue)
      };
    }
  });
}
/**
 * Conversion helper for downcasting attributes from the model table to a view table (not to `<figure>`).
 *
 * @param {module:engine/conversion/conversion~Conversion} conversion
 * @param {String} modelAttribute
 * @param {String} styleName
 */

export function downcastTableAttribute(conversion, modelAttribute, styleName) {
  conversion.for('downcast').add(function (dispatcher) {
    return dispatcher.on("attribute:".concat(modelAttribute, ":table"), function (evt, data, conversionApi) {
      var item = data.item,
          attributeNewValue = data.attributeNewValue;
      var mapper = conversionApi.mapper,
          writer = conversionApi.writer;

      if (!conversionApi.consumable.consume(data.item, evt.name)) {
        return;
      }

      var table = _toConsumableArray(mapper.toViewElement(item).getChildren()).find(function (child) {
        return child.is('element', 'table');
      });

      if (attributeNewValue) {
        writer.setStyle(styleName, attributeNewValue, table);
      } else {
        writer.removeStyle(styleName, table);
      }
    });
  });
}